import { render, staticRenderFns } from "./GridExTableData.vue?vue&type=template&id=1535d5cb&lang=pug"
import script from "./GridExTableData.vue?vue&type=script&lang=js"
export * from "./GridExTableData.vue?vue&type=script&lang=js"
import style0 from "./GridExTableData.vue?vue&type=style&index=0&id=1535d5cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VSimpleCheckbox,VTextField})
